import React, {useEffect, useState} from "react";
import {Stack} from "@mui/material";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import {EmpManagerRestControllerApiFactory, ManagerStats} from "arteco-api-client-ts";
import dayjs from "dayjs";
import {useApiManager} from "../../../components/utils/api";
import {EmptyState, Page, PageHeader, Panel, SkeletonRows} from "../../../components/kit";
import {EfficiencyIndicators} from "./emp_productivity_cads";
import {EmpProductivityChart} from "./emp_productivity_chart";
import {EmpProductivityBudgets} from "./emp_productivity_budgets";

/** Productividad del equipo que lleva la persona: desvíos, horas por tipo y presupuestos asignados. */
export function EmployeeProductivityPage() {
	const apiManager = useApiManager();
	const managerCtrl = apiManager.factory(EmpManagerRestControllerApiFactory);
	const [stats, setStats] = useState<ManagerStats | undefined>(undefined);

	useEffect(() => {
		apiManager.execute(managerCtrl.managerStats(undefined)).then(setStats);
	}, []);

	const hasData = stats && (stats.dedication?.workedHours || 0) > 0;

	return (
		<Page>
			<PageHeader title="Productividad"
						subtitle={stats?.lastMod ? `Datos actualizados el ${dayjs(stats.lastMod).format("D/M/YY [a las] HH:mm")}` : undefined}/>
			{!stats ? <SkeletonRows rows={3} height={120}/> : !hasData ? (
				<Panel><EmptyState icon={<InsightsRoundedIcon/>} title="No hay datos para mostrar"
								   description="Aparecerán cuando tu equipo tenga horas dedicadas en el año."/></Panel>
			) : (
				<Stack spacing={3}>
					<EfficiencyIndicators stats={stats}/>
					<EmpProductivityChart stats={stats}/>
					<EmpProductivityBudgets stats={stats}/>
				</Stack>
			)}
		</Page>
	);
}
